import React from 'react';
import EventHeader from '@features/eventDetail/components/EventHeader';
import EventLiveResultsList from '@features/results/components/EventLiveResultsList';

const EventLiveResultsTemplate = () => (
  <>
    <EventHeader />
    <EventLiveResultsList />
  </>
);

export default EventLiveResultsTemplate;
